import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import { CommonService } from '../../services/common/common.service';
import { UIReport } from '../../services/commonreports/common-reports.service';
import { UtilsService } from '../../services/utils/utils.service';

@Component({
    selector: 'app-reports-view',
    templateUrl: './reports-view.component.html',
    styleUrls: ['./reports-view.component.scss'],
    standalone: false,
})
export class ReportsViewComponent implements OnInit {
    generateReportsSubscription: Subscription;
    hiddenReportGenerationIcon = false;
    modifiedDoc: any;

    @Input() reports: UIReport[];
    @Input() isCancelledProcess?: boolean;
    @Output() generateReport = new EventEmitter();
    @Output() printReport = new EventEmitter();
    @Output() copyCheckSum = new EventEmitter();

    constructor(public commonService: CommonService, private _libUtils: UtilsService) {}

    trackByOrganization(_index: number, org: any): any {
        return org.name;
    }

    trackByMethod(index: number): any {
        return index;
    }

    public viewReport = (doc: any) => {
        this.commonService.viewDocument(doc);
    };

    public convertTime = data => {
        return this._libUtils.transformDateToLocale(data, 'YYYY-MM-DDTHH:MM:SSZ', 'DD-MM-YYYY HH:MM:SS AM', false);
    };

    ngOnInit() {}

    ngOnDestroy() {}
}
